import type { IndustryMeta } from '../client/IvtHubClient';

export function sortIndustries(list: IndustryMeta[]): IndustryMeta[] {
  return [...list].sort((a, b) => (a.industry ?? '').localeCompare(b.industry ?? '', 'en'));
}
